import { Avatar, Link, Stack, Typography } from '@mui/material';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { CompassRights, LeftArrow } from 'Images';

interface ITitle {
  count: number;
  displayCount: number;
}
export const Title = ({ count, displayCount }: ITitle) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userRights;
  const isDesktop = useIsDesktop();
  return isDesktop ? (
    <Stack flexDirection={'row'} alignItems={'center'} gap={'16px'}>
      <Avatar
        sx={{ width: '40px', height: '40px' }}
        alt=''
        src={CompassRights}
      />
      <Typography
        variant='body6'
        sx={{ maxWidth: isDesktop ? undefined : '318px' }}
      >
        {`${dictionary.subTitle.found} `}
        <strong>{count}</strong>
        {` ${dictionary.subTitle.rights} `}
        <strong>{displayCount}</strong>
        {` ${dictionary.subTitle.locationAt} `}
        <Link
          underline='none'
          display='inline-flex'
          alignItems='center'
          href='/compass-rights'
        >
          <Typography variant='body5'>{dictionary.compassRights}</Typography>
          <Avatar
            sx={{ width: '20px', height: '24px' }}
            alt=''
            src={LeftArrow}
          />
        </Link>
      </Typography>
    </Stack>
  ) : (
    <Stack
      sx={{
        padding: '16px 16px 20px 16px',
        gap: '10px',
        borderRadius: '12px',
        opacity: '0px',
        flexDirection: 'row',
        bgcolor: 'purple2.shade_100',
      }}
    >
      <Avatar
        sx={{ width: '40px', height: '40px' }}
        alt=''
        src={CompassRights}
      />
      <Stack gap='4px'>
        <Typography variant='body6' mb='8px'>
          {`${dictionary.subTitle.found} `}
          <strong>{count}</strong>
          {` ${dictionary.subTitle.rights.slice(0, 25)} `}
        </Typography>
        <Typography variant='body6'>
          {`${dictionary.subTitle.rights.slice(26)} `}
          <strong>{displayCount}</strong>
          {` ${dictionary.subTitle.locationAt}`}
        </Typography>
        <Link
          underline='none'
          display='inline-flex'
          alignItems='center'
          href='/compass-rights'
        >
          <Typography variant='body5'>{dictionary.compassRights}</Typography>
          <Avatar
            sx={{ width: '20px', height: '24px' }}
            alt=''
            src={LeftArrow}
          />
        </Link>
      </Stack>
    </Stack>
  );
};
